import type React from 'react'
import { CHECKOUT_URL } from '../data/checkout'
import { withUtmParams } from './checkoutUrl'
import { trackInitiateCheckout } from './metaPixel'

/** True only when a real https checkout destination has been configured. */
export function isCheckoutConfigured(): boolean {
  return /^https:\/\/\S+$/.test(CHECKOUT_URL)
}

export function getCheckoutHref(): string | undefined {
  return isCheckoutConfigured() ? withUtmParams(CHECKOUT_URL) : undefined
}

/** Shared click handler for every Welding purchase button. */
export function handleCheckoutClick(event: React.MouseEvent<HTMLAnchorElement>): void {
  if (!isCheckoutConfigured()) {
    event.preventDefault()
    return
  }
  trackInitiateCheckout()
  // Re-resolve at click time so the link always carries the visitor's UTMs.
  event.currentTarget.href = withUtmParams(CHECKOUT_URL)
}
